import client, { unwrap } from './client';

export const getSalesDatasets = () =>
  client.get('/profit-pulse/sales').then(unwrap);

/** The server parses the CSV and caches it under the returned token. */
export const previewSales = (text, source) =>
  client.post('/profit-pulse/sales/preview', { text, source }).then(unwrap);

/** body: { token, fileName?, month?, mode? } */
export const importSales = (body) =>
  client.post('/profit-pulse/sales/import', body).then(unwrap);
